
import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

export const TruncatedText = styled(Typography)<{ maxlines?: number }>(({ maxlines }) => {
  if (!maxlines) return {};
  return {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: maxlines,
  };
});

export const StyledIconBox = styled(Box)`
  cursor: pointer;
  width: 30px;
  height: 30px;
`;
